import { fetchRequestSend } from "../../../helpers/common-helpers";
import PopupClass from "../../../components/common/PopupClass";
import l10n from "../../../lang/locallang";

export default class AssessmentCaptivatePublic {
    /**
     * Displays the assessment popup if the response status is true.
     * @param {Object} response - The response object from the server.
     * @param {string} popupSize - The size of the popup ('small' or 'large').
     * @param {string} topicId - The ID of the topic.
     * @param {string} parentTopicId - The ID of the parent topic.
     * @param {string} stage - The assessment stage ('pre' or 'post').
     */
    view(response, popupSize, topicId, parentTopicId, stage) {

        if (response.status) {
            this.topicId = topicId;
            this.parentTopicId = parentTopicId;
            this.popup = new PopupClass();
            this.popupSize = popupSize;
            this.stage = stage;

            this.openPopup(popupSize, response.content, response.question, response.response);
        }
    }

    /**
     * Fetches and displays the question for the given topic.
     * @param {string} topicId - The ID of the topic.
     * @param {string} parentTopicId - The ID of the parent topic.
     * @param {string} popupSize - The size of the popup ('small' or 'large').
     */
    // getQuestion(topicId, parentTopicId, popupSize) {
    //     const questionTopicId = parentTopicId || topicId;
    //
    //     fetchRequestSend(getQuestionURL, 'POST', { topic_id: questionTopicId }).then(response => {
    //         if (response.question) {
    //             const selector = popupSize === 'small'
    //                 ? '#playerModal .content-question'
    //                 : '#lesson-popup-large .content-question';
    //             document.querySelector(selector).innerHTML = response.question;
    //         }
    //     });
    // }

    /**
     * Fetches and displays the answer for the given topic.
     * @param {string} topicId - The ID of the topic.
     * @param {string} parentTopicId - The ID of the parent topic.
     */
    async getAnswer(topicId, parentTopicId) {
        const answerTopicId = parentTopicId || topicId;
        try {
            const response = await fetchRequestSend(getAnswerUrl, 'POST', { topic_id: answerTopicId });
            if (response.response) {
                let popupElement = document.querySelector('#captivateResult');
                popupElement.querySelector('.simulation__answer-label').style.display = 'block';
                popupElement.querySelector('.simulation__answer-text').innerHTML = response.response;
            }
            return response; // Return the response
        } catch (error) {
            console.error("Error fetching answer:", error);
            throw error; // Re-throw the error
        }
    }
    /**
     * Opens the assessment popup with the given content URL.
     * @param {string} popupSize - The size of the popup ('small' or 'large').
     * @param {string} contentURL - The URL of the content to display in the popup.
     */
    openPopup(popupSize, contentURL, question, response) {
        //console.log('openpopup', response);
        const { preAssessment, postAssessment } = l10n.textTopicResultNotification;
        const topicRow = document.querySelector(`.tr-course-progress[data-row-topic-id="${this.topicId}"]`);
        this.topicName = topicRow.querySelector('.skill-name').innerText ? topicRow.querySelector('.skill-name').innerText : topicRow.querySelector('.skill-name').value;

        const popupType = popupSize === 'small' ? 'playerModal' : 'lesson-popup-large';
        this.popup.open(popupType);

        const iframeSelector = popupSize === 'small' ? '#contentFrame' : '#contentFrameLarge';
        const iframe = document.querySelector(iframeSelector);
        iframe.src = contentURL;

        const popupElement = document.querySelector(`#${popupType}`);
        const assessmentTitle = popupElement.querySelector('.player-content-type');
        assessmentTitle.innerHTML = this.stage === 'pre' ? preAssessment : postAssessment;
        // clean style attribute to sidebar
        popupElement.querySelector('.popup-sidebar').removeAttribute('style');

        const topicName = popupElement.querySelector('.player-text');
        topicName.innerText = this.topicName;

        // set question
        //let assessmentElement = topicRow.querySelector('.run-assessment');
        //if(topicRow.dataset.rowQuestion){
            //topicRow.querySelector('.run-assessment').classList.add('active');
        const selector = popupSize === 'small'
            ? '#playerModal .content-question'
            : '#lesson-popup-large .content-question';
        document.querySelector(selector).innerHTML = question;
        // set response to answer
        let popupResult = document.querySelector('#captivateResult');
        popupResult.querySelector('.simulation__answer-text').innerHTML = response;
       // }
        //this.getQuestion(this.topicId, this.parentTopicId, popupSize);
    }
}
